import { render } from "./HomeView.vue?vue&type=template&id=657ce6fa&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=657ce6fa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\vue_php_crud\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657ce6fa"]])

export default __exports__